import React, { Fragment } from 'react'
import styled from 'styled-components'
import { media, style } from 'app/assets/styles'
import { FormattedMessage } from 'react-intl'
import { ModalTitle } from 'app/common/modals/title'
import { H3, H5, H6, Text } from 'app/common/typography'
import { CashRegister, Drive, PreOrder } from 'app/assets/icons'
import { colors } from 'shared/assets/styles'
import { toSrcSet } from 'shared/utils'
import { Picture } from 'react-responsive-picture'
import Modal from 'react-modal'
import tutorial_privileges_1x from 'shared/assets/images/tutorial_privileges.png'
import tutorial_privileges_2x from 'shared/assets/images/tutorial_privileges@2x.png'
import tutorial_privileges_3x from 'shared/assets/images/tutorial_privileges@3x.png'
import background_kingdom from 'shared/assets/images/background_kingdom.jpg'

const images = [
    tutorial_privileges_1x,
    tutorial_privileges_2x,
    tutorial_privileges_3x
]
const { yellow, lightOrange, text } = colors

type Props = {
    isOpen: boolean,
    mobile: boolean,
    handleClose: () => void
}

const TutorialModal = (props: Props) => {
    const { isOpen, mobile, handleClose } = props
    return (
        <Modal
            ariaHideApp={false}
            isOpen={isOpen}
            shouldCloseOnOverlayClick
            onRequestClose={handleClose}
            style={
                mobile ? style.classicModalMobileStyle : style.classicModalStyle
            }>
            <Container>
                <ModalTitle
                    center
                    handleClose={handleClose}
                    color="white"
                    titleNode={
                        <Fragment>
                            <FormattedMessage id="modal.tutorial.title">
                                {(text: string) => (
                                    <StyledH3 center color={yellow}>
                                        {text}
                                    </StyledH3>
                                )}
                            </FormattedMessage>
                            <FormattedMessage id="help.privileges">
                                {(text: string) => (
                                    <StyledH5 center color="white">
                                        {text}
                                    </StyledH5>
                                )}
                            </FormattedMessage>
                        </Fragment>
                    }
                />
                <Number>
                    <H6 center color="white">
                        1
                    </H6>
                </Number>
                <Paragraph>
                    <FormattedMessage id="kingdom.privileges.tuto.description.1">
                        {(text: string) => <Text color="white">{text}</Text>}
                    </FormattedMessage>
                </Paragraph>
                <StyledPicture
                    sources={[
                        {
                            srcSet: toSrcSet(images)
                        }
                    ]}
                />
                <Number>
                    <H6 center color="white">
                        {' '}
                        2{' '}
                    </H6>
                </Number>
                <Paragraph>
                    <FormattedMessage id="kingdom.privileges.tuto.description.2">
                        {(text: string) => <Text color="white">{text}</Text>}
                    </FormattedMessage>
                </Paragraph>
                <Wrapper>
                    <Item>
                        <PreOrder size={40} color={text} />
                        <FormattedMessage id="kingdom.privileges.tuto.borne">
                            {(label: string) => <StyledH6>{label}</StyledH6>}
                        </FormattedMessage>
                    </Item>
                    <Item>
                        <CashRegister size={40} color={text} />
                        <FormattedMessage id="kingdom.privileges.tuto.cashregister">
                            {(label: string) => <StyledH6>{label}</StyledH6>}
                        </FormattedMessage>
                    </Item>
                    <Item>
                        <Drive size={40} color={text} />
                        <FormattedMessage id="kingdom.privileges.tuto.drive">
                            {(label: string) => <StyledH6>{label}</StyledH6>}
                        </FormattedMessage>
                    </Item>
                </Wrapper>
            </Container>
            <DriveHelper>
                <FormattedMessage id="kingdom.privileges.tuto.drive.help">
                    {(label: string) => (
                        <H5 center color="white">
                            {label}
                        </H5>
                    )}
                </FormattedMessage>
                <FormattedMessage id="kingdom.privileges.tuto.drive.description">
                    {(label: string) => <H6 center>{label}</H6>}
                </FormattedMessage>
            </DriveHelper>
        </Modal>
    )
}

const Container = styled.div`
    padding: 15px;
    min-height: 100%;
    ${media.medium`
        padding: 40px;
    `};
    background-image: url(${background_kingdom});
`

const Wrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin: 10px 0;
`

const Item = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 15px 10px;
    margin: 0 5px;
    background-color: ${lightOrange};
    border-radius: 10px;
    width: 25%;
`

const StyledH6 = styled(H6)`
    margin-top: 10px;
`

const Paragraph = styled.p`
    margin: 10px auto;
    text-align: center;
`

const StyledH3 = styled(H3)`
    margin-top: -15px;
    ${media.medium`
        margin-top: -50px;
    `};
`

const StyledH5 = styled(H5)`
    margin-top: -5px;
    margin-bottom: 20px;
`

const StyledPicture = styled(Picture)`
    width: calc(100% - 120px);
    font-size: 0;
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: center;
`

const Number = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    background: ${yellow};
    border-radius: 10px;
    margin: auto;
    width: 35px;
    height: 35px;
`

const DriveHelper = styled.div`
    padding: 25px;
    background: ${yellow};
    margin-top: -20px;
`

export { TutorialModal }
